import { formatters } from '@Components/hierarchical-report/Layout'

export const COLLECTION_GROUPBY = {
  impression: [
    { value: 'publisher', label: 'Publisher', group: 'Traffic' },
    { value: 'allocation', label: 'Allocation', group: 'Traffic' },
    { value: 'sid1', label: 'SubID 1', group: 'Traffic' },
    { value: 'sid2', label: 'SubID 2', group: 'Traffic' },
    { value: 'device', label: 'Device', group: 'Traffic' },
    { value: 'optout', label: 'Optout', group: 'Traffic' },
    { value: 'domain', label: 'Domain', group: 'Traffic' },
    { value: 'offer', label: 'Offer', group: 'User Session' },
    { value: 'hour_session', label: 'Creation Hour', group: 'User Session' },
    { value: 'day_session', label: 'Creation Day', group: 'User Session' },
    { value: 'month_session', label: 'Creation Month', group: 'User Session' },
    { value: 'registrationCompleted', label: 'Registration Completed', group: 'User Session' },
    { value: 'duplicated', label: 'Duplicated', group: 'User Session' },
    { value: 'pathUserProfile', label: 'Path User Profile', group: 'Midpath' },
    { value: 'path', label: 'Path', group: 'Midpath' },
    { value: 'slot', label: 'Slot', group: 'Midpath' },
    { value: 'page', label: 'Page', group: 'Midpath' },
    { value: 'pageVersion', label: 'Page Version', group: 'Midpath' },
    { value: 'partner', label: 'Partner', group: 'Midpath' },
    { value: 'completedOrigin', label: 'Completed Origin', group: 'Midpath' },
    { value: 'pathContainerSlot', label: 'Path Container Slot', group: 'Midpath' },
    { value: 'experimentVersion', label: 'Experiment Version', group: 'Midpath' },
    { value: 'fraudScore', label: 'Fraud Score', group: 'Midpath' },
    { value: 'fraudVerification', label: 'Fraud Verification', group: 'Midpath' },
    { value: 'hour', label: 'Hour', group: 'Full Time' },
    { value: 'day', label: 'Day', group: 'Full Time' },
    { value: 'month', label: 'Month', group: 'Full Time' },
    { value: 'year', label: 'Year', group: 'Full Time' },
    { value: 'city', label: 'City', group: 'Consumer' },
    { value: 'state', label: 'State', group: 'Consumer' },
    { value: 'emailDomain', label: 'Email Domain', group: 'Consumer' },
    { value: 'age', label: 'Age', group: 'Consumer' },
    { value: 'gender', label: 'Gender', group: 'Consumer' },
  ],
  session: [
    { value: 'publisher', label: 'Publisher', group: 'Traffic' },
    { value: 'allocation', label: 'Allocation', group: 'Traffic' },
    { value: 'offer', label: 'Offer', group: 'Traffic' },
    { value: 'campaignid', label: 'Campaign Id', group: 'Traffic' },
    { value: 'conversiontype', label: 'Conversion Type', group: 'Traffic' },
    { value: 'payouttype', label: 'Payout Type', group: 'Traffic' },
    { value: 'subId', label: 'SubID 1', group: 'Traffic' },
    { value: 'subId2', label: 'SubID 2', group: 'Traffic' },
    { value: 'subId3', label: 'SubID 3', group: 'Traffic' },
    { value: 'duplicatedData', label: 'Duplicated Data', group: 'Traffic' },
    { value: 'duplicatedClick', label: 'Duplicated Click', group: 'Traffic' },
    { value: 'duplicated', label: 'Duplicated', group: 'Traffic' },
    { value: 'dupeDaysDelta', label: 'Dupe Days Delta', group: 'Traffic' },
    { value: 'domain', label: 'Domain', group: 'Traffic' },
    { value: 'converted', label: 'Converted', group: 'Traffic' },
    { value: 'isLoss', label: 'Is Loss', group: 'Traffic' },
    { value: 'rev__origin', label: 'Revenue Origin', group: 'Traffic' },
    { value: 'rev__externalId', label: 'Revenue External ID', group: 'Traffic' },
    { value: 'rev__integrationId', label: 'Revenue Integration ID', group: 'Traffic' },
    { value: 'registration_completed', label: 'Completed', group: 'Registration' },
    { value: 'registrationTotalSteps', label: 'Total Steps', group: 'Registration' },
    { value: 'registrationLastStep', label: 'Last Step', group: 'Registration' },
    { value: 'tcpaConsent', label: 'TCPA Consent', group: 'Registration' },
    { value: 'skipRegistration', label: 'Skipped', group: 'Registration' },
    { value: 'registrationConsent', label: 'Reg. Consent', group: 'Registration' },
    { value: 'registrationCount', label: 'Registrations Count', group: 'Consumer' },
    { value: 'fraud_verification', label: 'Fraud', group: 'Verifications' },
    { value: 'fraudScore', label: 'Fraud Score', group: 'Verifications' },
    { value: 'emailVerification', label: 'Email', group: 'Verifications' },
    { value: 'addressVerification', label: 'Address', group: 'Verifications' },
    { value: 'botVerification', label: 'Bot', group: 'Verifications' },
    { value: 'postalVerification', label: 'Postal', group: 'Verifications' },
    { value: 'phoneVerification', label: 'Phone', group: 'Verifications' },
    { value: 'form', label: 'Form', group: 'Form' },
    { value: 'formConversionStep', label: 'Conversion Step', group: 'Form' },
    { value: 'site', label: 'Site', group: 'Organization' },
    { value: 'hour', label: 'Hour', group: 'Full Time' },
    { value: 'day', label: 'Day', group: 'Full Time' },
    { value: 'month', label: 'Month', group: 'Full Time' },
    { value: 'year', label: 'Year', group: 'Full Time' },
    { value: 'device', label: 'Device', group: 'Request' },
    { value: 'os', label: 'OS', group: 'Request' },
    { value: 'browser', label: 'Browser', group: 'Request' },
    { value: 'post', label: 'Post', group: 'CMS' },
    { value: 'post_version', label: 'Post Version', group: 'CMS' },
    { value: 'post_target', label: 'Post Target', group: 'CMS' },
    { value: 'city', label: 'City', group: 'Consumer' },
    { value: 'state', label: 'State', group: 'Consumer' },
    { value: 'emaildomain', label: 'Email Domain', group: 'Consumer' },
    { value: 'age', label: 'Age', group: 'Consumer' },
    { value: 'age_legacy', label: 'Age (legacy)', group: 'Consumer' },
    { value: 'gender', label: 'Gender', group: 'Consumer' },
    { value: 'optout', label: 'Optout', group: 'Consumer' },
  ],
  integration: [
    { value: 'integration', label: 'Integration', group: 'Integration' },
    { value: 'type', label: 'Integration Type', group: 'Integration' },
    { value: 'vendor', label: 'Vendor', group: 'Integration' },
    { value: 'trigger', label: 'Trigger', group: 'Integration' },
    { value: 'publisher', label: 'Publisher', group: 'Traffic' },
    { value: 'allocation', label: 'Allocation', group: 'Traffic' },
    { value: 'sid1', label: 'SubID 1', group: 'Traffic' },
    { value: 'hour', label: 'Delivery Hour', group: 'Date Intervals' },
    { value: 'day', label: 'Delivery Day', group: 'Date Intervals' },
    { value: 'month', label: 'Delivery Month', group: 'Date Intervals' },
    { value: 'year', label: 'Delivery Year', group: 'Date Intervals' },
    { value: 'day_session', label: 'Creation Day', group: 'Date Intervals' },
    { value: 'month_session', label: 'Creation Month', group: 'Date Intervals' },
    { value: 'week_session', label: 'Creation Week', group: 'Date Intervals' },
    { value: 'registration_consent', label: 'Registration Consent', group: 'Session' },
    { value: 'registration_completed', label: 'Registration Completed', group: 'Session' },
  ],
  bucketrans: [
    { value: 'day', label: 'Day', group: 'Full Time' },
    { value: 'hour', label: 'Hour', group: 'Full Time' },
    { value: 'month', label: 'Month', group: 'Full Time' },
    { value: 'year', label: 'Year', group: 'Full Time' },
    { value: 'hour_unittime', label: 'Hour of Day', group: 'Unit Time' },
    { value: 'day_unittime', label: 'Day of Month', group: 'Unit Time' },
    { value: 'weekday_unittime', label: 'Weekday', group: 'Unit Time' },
    { value: 'month_unittime', label: 'Month of Year', group: 'Unit Time' },
    { value: 'publisher', label: 'Publisher', group: 'Traffic' },
    { value: 'subid', label: 'SubID', group: 'Traffic' },
    { value: 'allocation', label: 'Allocation', group: 'Entity' },
    { value: 'bucket', label: 'Bucket', group: 'Entity' },
    { value: 'pekey', label: 'PE Key', group: 'Entity' },
    { value: 'organization', label: 'Organization', group: 'Organization' },
    { value: 'site', label: 'Site', group: 'Organization' },
    { value: 'uniqUser', label: 'Unique User', group: 'Session' },
    { value: 'uniqPathSession', label: 'Unique Path Session', group: 'Session' },
    { value: 'uniqUserSession', label: 'Unique User Session', group: 'Session' },
    { value: 'action', label: 'Action', group: 'Session' },
  ],
}

export function getCollectionGroupbyOptions(collection) {
  return COLLECTION_GROUPBY[collection] || []
}

export function getGroupbyOption(collection, field) {
  return getCollectionGroupbyOptions(collection).find(option => option.value === field)
}

export function getGroupbyFieldLabel(collection, field) {
  return getGroupbyOption(collection, field)?.label || formatters.groupsText(field || '')
}

export function getCollectionGroupbyGroups(collection) {
  const grouped = new Map()

  getCollectionGroupbyOptions(collection).forEach(option => {
    if (!grouped.has(option.group)) grouped.set(option.group, [])
    grouped.get(option.group).push(option)
  })

  return [...grouped.entries()]
}

export function isGroupbyAvailable(collection, field) {
  return Boolean(getGroupbyOption(collection, field))
}

export function pruneGroupbyForCollection(groupby = [], collection) {
  const available = groupby.filter(field => isGroupbyAvailable(collection, field))
  if (available.length) return available

  const [fallback] = getCollectionGroupbyOptions(collection)
  return fallback ? [fallback.value] : []
}
